import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { GetmIconService, GetmIconSize, GetmIconVariant } from '../../services/getm-icon/getm-icon.service';

export { GetmIconSize, GetmIconVariant };

@Component({
  selector: 'app-icon-getm',
  templateUrl: './icon-getm.component.html',
  styleUrls: ['./icon-getm.component.scss']
})
export class IconGetmComponent implements OnChanges {

  @Input() name = '';
  @Input() variant: GetmIconVariant = 'outline';
  @Input() size: GetmIconSize = 'm';
  @Input() color = '';
  @Input() customSize = '';

  public iconSize = '24px';

  constructor(private getmIconService: GetmIconService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.size || changes.customSize) {
      this.updateIconSize();
    }
  }

  private updateIconSize(): void {
    if (this.customSize) {
      this.iconSize = this.customSize;
      return;
    }
    this.iconSize = this.getmIconService.getSizeString(this.size);
  }

}
